import { useState, useEffect } from 'react';

interface NavigationProps {
  scrolled: boolean;
  onNavigate?: (sectionId: string) => void;
}

export default function Navigation({ scrolled, onNavigate }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (sectionId: string) => {
    if (onNavigate) {
      onNavigate(sectionId);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-4 sm:px-6 lg:px-20 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <h1 
                className={`text-4xl font-extrabold whitespace-nowrap transition-colors duration-300 ${
                  scrolled 
                    ? 'bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent' 
                    : 'text-white drop-shadow-lg'
                }`}
                translate="no"
              >
                KIMURAMA WORKS
              </h1>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => handleNavClick('services')}
              className={`text-lg font-bold transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-purple-900 hover:text-purple-600' : 'text-white hover:text-purple-200'
              }`}
            >
              サービス
            </button>
            <button
              onClick={() => handleNavClick('portfolio')}
              className={`text-lg font-bold transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-purple-900 hover:text-purple-600' : 'text-white hover:text-purple-200'
              }`}
            >
              実績
            </button>
            <button
              onClick={() => handleNavClick('about')}
              className={`text-lg font-bold transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-purple-900 hover:text-purple-600' : 'text-white hover:text-purple-200'
              }`}
            >
              私について
            </button>
            <a
              href="/blog"
              className={`text-lg font-bold transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-purple-900 hover:text-purple-600' : 'text-white hover:text-purple-200'
              }`}
            >
              ブログ
            </a>
            <button
              onClick={() => handleNavClick('contact')}
              className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-3 rounded-full text-lg font-bold hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden cursor-pointer ${scrolled ? 'text-purple-900' : 'text-white'}`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-2xl shadow-lg">
            <div className="flex flex-col gap-4 p-4">
              <button
                onClick={() => handleNavClick('services')}
                className="text-lg font-bold text-purple-900 hover:text-purple-600 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                サービス
              </button>
              <button
                onClick={() => handleNavClick('portfolio')}
                className="text-lg font-bold text-purple-900 hover:text-purple-600 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                実績
              </button>
              <button
                onClick={() => handleNavClick('about')}
                className="text-lg font-bold text-purple-900 hover:text-purple-600 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                私について
              </button>
              <a
                href="/blog"
                className="text-lg font-bold text-purple-900 hover:text-purple-600 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                ブログ
              </a>
              <button
                onClick={() => handleNavClick('contact')}
                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-3 rounded-full text-lg font-bold hover:from-purple-600 hover:to-pink-600 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
              >
                お問い合わせ
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}